import logout from '@src/navigation/logout';
import ModalOld from '../components/modals/ModalOld';
import {
  checkIsGuardValidation,
  checkSuperAdminValidation,
  checkCompanyOwnerValidation,
} from '../utility/validators/role-validtion';
import navigation from '@src/navigation/vertical';
import Loader from '../components/modals/Loader/Loader';
import useShowComingSoon from '../utility/hooks/useShowComingSoon';
import { useIsLoggedIn, useProfile } from '../store/Auth/authHooks';
import Layout from '../components/overwritten-core/layouts/VerticalLayout';
import {
  useIsLoaderActive,
  useIsOldModalOpen,
} from '../store/modal/modalHooks';
import Footer from '../components/overwritten-core/layouts/components/footer';
import { useGetLocation } from '../store/RoomManagement/resourceManagementHooks';

const VerticalLayout = (props) => {
  const profile = useProfile();
  const location = useGetLocation();
  const isLoggedIn = useIsLoggedIn();
  const isOldModalOpen = useIsOldModalOpen();
  const isLoaderActive = useIsLoaderActive();

  const [, setShowComingSoon] = useShowComingSoon();

  return (
    <Layout
      menuData={navigation(
        checkCompanyOwnerValidation(profile),
        setShowComingSoon,
        checkSuperAdminValidation(profile),
        isLoggedIn,
        checkIsGuardValidation(profile),
        location
      )}
      logout={isLoggedIn ? logout : null}
      {...props}
      footer={<Footer />}
    >
      {isOldModalOpen && <ModalOld />}
      {isLoaderActive && <Loader />}
      {props.children}
    </Layout>
  );
};

export default VerticalLayout;
